<template>
  <div class="x-table-page">
    <slot name="tableTop"></slot>
    <div class="x-table">
      <el-table
        ref="tableRef"
        v-bind="$attrs"
        :stripe="isStripe"
        :header-cell-style="{ background: '#fafafa' }"
        :data="pagination !== false ? localDataSource : dataSource"
        :class="{wrapper:wrapper}"
      >
        <el-table-column
          v-for="column in columns"
          :key="column.prop"
          v-bind="column"
          :align="align"
          :minWidth="$t('common.mode') === 'en' ? column.minWidthEn || column.minWidth : column.minWidth"
        >
          <template v-if="column.slotTitle" #header>
            <slot :name="column.slotTitle" :column="column"></slot>
          </template>
          <template v-if="column.scopedSlots" #default="scope">
            <slot :name="column.scopedSlots" v-bind="scope"></slot>
          </template>
        </el-table-column>
        <template #empty>
          <el-row justify="center">
            <img
              src="@/assets/images/empty-bg.png"
              :style="{ margin: emptyMargin }"
              class="empty-png"
              alt=""
            />
          </el-row>
          <slot name="empty">
            <div class="empty">{{$t('commonComponents.noData')}}</div>
          </slot>
        </template>
      </el-table>
      <slot name="pagination">
        <el-row
          align="middle"
          justify="end"
          class="pagination"
          v-if="pagination !== false && !!dataSource.length"
        >
          <el-pagination
            :total="dataSource.length"
            :current-page="currentPage"
            v-bind="localPagination"
            @current-change="currentChange"
          />
        </el-row>
      </slot>
    </div>
  </div>
</template>

<script setup>
import { $t } from '@/i18n';
import { ref, unref, onMounted, mergeProps, watch } from 'vue'

defineExpose({
  tableFn
})

const props = defineProps({
  columns: Array,
  dataSource: {
    type: Array,
    default: () => []
  },
  isStripe: {
    type: Boolean,
    default: true
  },
  // 分页配置
  pagination: {
    type: [Boolean, Object],
    default: () => ({})
  },
  // 空数据展示时magin距离
  emptyMargin: {
    type: String,
    defailt: '60px 0 16px'
  },
  align: {
    type: String,
    default: 'left'
  },
  wrapper: {
    type: Boolean,
    default: false
  }
})

const localDataSource = ref([])
const currentPage = ref(1)
const localPagination = ref(
  mergeProps(
    {
      pageSize: 10
    },
    props.pagination
  )
)
const tableRef = ref()
function currentChange(_currentPage) {
  currentPage.value = _currentPage
  const pageSize = unref(localPagination).pageSize
  let endIndex = _currentPage * pageSize
  if (endIndex > props.dataSource.length) {
    endIndex = props.dataSource.length
  }
  localDataSource.value = props.dataSource.slice(
    (_currentPage - 1) * pageSize,
    endIndex
  )
}

onMounted(() => {
  currentChange(1)
})

watch(
  () => props.dataSource,
  (value, oldValue) => {
    currentChange(unref(currentPage))
  }
)

watch(
  () => props.dataSource.length,
  (value, oldValue) => {
    currentChange(unref(currentPage))
  }
)

function tableFn(fnName) {
  const args = [...arguments]
  return unref(tableRef)[fnName](...args.slice(1))
}
</script>

<style lang="scss" scoped>
.x-table-page {
  padding-left: 24px;
  margin-right: 24px;
}

.pagination {
  display: flex;
  justify-content: flex-end;
  margin-top: 16px;
  padding-bottom: 16px;
}

.wrapper {
  border: 1px solid var(--el-border-color-lighter);
  border-bottom: none;

  :deep(.el-table__inner-wrapper:before) {
    height: 0;
  }
}
</style>

<style lang="scss">
.x-table-page {
  .x-form {
    .el-input,
    .el-date-editor,
    .el-select__wrapper {
      height: 36px;
    }
  }

  thead {
    height: 54px;
    background-color: #fafafa;

    .cell {
      color: #151515;
      font-weight: 600;
    }
  }

  tbody {
    .cell {
      color: #151515;
      font-weight: 400;
    }

    .el-table__row {
      height: 52px !important;
    }
  }

  .empty {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .empty-png {
    width: 120px;
    height: 100px;
  }
}
</style>
